import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const BriefcaseShape = ({
  width = 14,
  height = 14,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 14"
    fill={fillColor}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9375 2.8125H11.475C10.8 1.125 9.16875 0 7.3125 0C5.45625 0 3.825 1.125 3.15 2.8125H1.6875C0.73125 2.8125 0 3.54375 0 4.5V4.8375C0 6.80625 1.63125 8.4375 3.6 8.4375H11.0813C13.05 8.4375 14.6813 6.80625 14.6813 4.8375V4.5C14.625 3.54375 13.8938 2.8125 12.9375 2.8125ZM7.3125 1.125C8.55 1.125 9.61875 1.8 10.2375 2.8125H4.3875C5.00625 1.8 6.075 1.125 7.3125 1.125Z"
      fill={fillColor}
    />
    <path
      d="M11.25 9.56252V10.6875C11.25 11.025 11.025 11.25 10.6875 11.25C10.35 11.25 10.125 11.025 10.125 10.6875V9.56252H4.5V10.6875C4.5 11.025 4.275 11.25 3.9375 11.25C3.6 11.25 3.375 11.025 3.375 10.6875V9.56252C2.025 9.50627 0.84375 8.88752 0 7.93127V11.8125C0 12.7688 0.73125 13.5 1.6875 13.5H12.9375C13.8938 13.5 14.625 12.7688 14.625 11.8125V7.93127C13.7812 8.88752 12.6 9.50627 11.25 9.56252Z"
      fill={fillColor}
    />
  </svg>
);

export default BriefcaseShape;